export const programs = [
  {
    slug: "kemiskinan",
    title: "Kemiskinan",
    description: "Program pemberdayaan masyarakat untuk mengatasi kemiskinan melalui pendekatan ekonomi, sosial, dan kemanusiaan.",
    content: [
      "Kemiskinan masih menjadi tantangan besar di Indonesia, khususnya di wilayah terpencil dan kelompok masyarakat rentan. dan Keterbatasan akses pendidikan, lapangan kerja, serta layanan dasar menyebabkan banyak keluarga hidup dalam kondisi tidak layak. Melalui kolaborasi dengan mitra dan filantropi, Belas Kasih mendorong pemberdayaan berkelanjutan agar masyarakat dapat mandiri. ",
    ],
    stats: [
      { label: "Keluarga Terdampak", value: "1.200+" },
      { label: "Wilayah Prioritas", value: "15+" },
      { label: "Masyarakat Rentan", value: "25%" },
    ],
  },

  {
    slug: "yatim-dhuafa",
    title: "Yatim & Dhuafa",
    description: "Dukungan pendidikan, kesehatan, dan kebutuhan dasar bagi anak-anak dan keluarga dhuafa.",
    content: ["Anak yatim dan keluarga dhuafa membutuhkan perhatian khusus untuk memastikan masa depan yang lebih baik.", "Program ini berfokus pada pendidikan, nutrisi, serta pendampingan psikososial."],
    stats: [
      { label: "Anak Dibantu", value: "800+" },
      { label: "Program Pendidikan", value: "20+" },
      { label: "Mitra Aktif", value: "30+" },
    ],
  },

  {
    slug: "janda",
    title: "Janda",
    description: "Program pemberdayaan perempuan kepala keluarga untuk memperkuat kemandirian ekonomi dan kesejahteraan keluarga.",
    content: [
      "Banyak perempuan yang harus menjalani peran sebagai kepala keluarga setelah kehilangan pasangan, dengan keterbatasan akses ekonomi dan sosial.",
      "Program ini berfokus pada pemberdayaan ekonomi, pelatihan keterampilan, serta pendampingan berkelanjutan agar para janda dapat mandiri dan berdaya.",
    ],
    stats: [
      { label: "Perempuan Dibantu", value: "600+" },
      { label: "Program Pelatihan", value: "18+" },
      { label: "Wilayah Dampak", value: "12+" },
    ],
  },

  {
    slug: "bencana-alam",
    title: "Bencana Alam",
    description: "Respon cepat dan pemulihan pascabencana bagi masyarakat terdampak bencana alam di Indonesia.",
    content: [
      "Indonesia merupakan negara rawan bencana alam seperti banjir, gempa bumi, dan longsor yang berdampak langsung pada kehidupan masyarakat.",
      "Program ini berfokus pada bantuan darurat, pemenuhan kebutuhan dasar, serta pemulihan pascabencana agar masyarakat dapat bangkit kembali.",
    ],
    stats: [
      { label: "Wilayah Terdampak", value: "25+" },
      { label: "Keluarga Dibantu", value: "2.000+" },
      { label: "Respon Darurat", value: "40+" },
    ],
  },
];
